/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const o = "dialogs.windowMaximizeButton", i = "dialogs.windowMinimizeButton", t = "dialogs.windowRestoreButton", n = "dialogs.windowCloseButton", s = {
  [o]: "maximize",
  [i]: "minimize",
  [t]: "restore",
  [n]: "close"
};
export {
  n as dialogsWindowCloseButton,
  o as dialogsWindowMaximizeButton,
  i as dialogsWindowMinimizeButton,
  t as dialogsWindowRestoreButton,
  s as messages
};
